import Select, {Props as SelectProps} from 'components/Select';

import DropdownIndicator from './components/DropdownIndicator';
import SingleValue from './components/SingleValue';

import styles from './Filter.module.scss';

function Filter({size = 'md', ...restProps}: SelectProps) {
  return (
    <Select
      className={styles.root}
      size={size}
      {...restProps}
      components={{DropdownIndicator, SingleValue}}
    />
  );
}

export default Filter;
